<template>
  <div class="agent-task-bubble" id="agentTaskBubble" :class="{ open: open }" :style="bubbleStyle">
    <div class="agent-task-bubble-head">
      <div class="agent-task-bubble-title">定时任务</div>
      <button class="agent-task-bubble-close" type="button" data-agent-task-bubble-close @click="close">×</button>
    </div>
    <div class="agent-task-bubble-list">
      <button
        v-if="tasks.length === 0"
        class="agent-task-bubble-item"
        type="button"
      >
        <div class="agent-task-bubble-name">当前没有定时任务</div>
      </button>
      <button
        v-for="task in tasks"
        :key="task.id"
        class="agent-task-bubble-item"
        type="button"
        :data-agent-task-open="task.id"
        @click="openTask(task.id)"
      >
        <div class="agent-task-bubble-name">{{ task.title }}</div>
        <div class="agent-task-bubble-meta">
          <span>{{ task.status }}</span>
          <span v-if="task.totalRuns != null">已执行 {{ task.totalRuns }} 次</span>
          <span>{{ task.dueTime }}</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'AgentTaskBubble',
  computed: {
    ...mapState(['agentTaskBubble']),
    ...mapGetters(['currentAgentTasks']),
    open() { return this.agentTaskBubble.open },
    tasks() { return this.currentAgentTasks },
    bubbleStyle() {
      const x = this.agentTaskBubble.x
      const y = this.agentTaskBubble.y
      if (x == null || y == null) return {}
      return { position: 'fixed', left: x + 'px', top: y + 'px' }
    }
  },
  methods: {
    ...mapActions(['closeAgentTaskBubble', 'openAgentTaskPreview']),
    close() { this.closeAgentTaskBubble() },
    openTask(id) { this.openAgentTaskPreview(id) },
    handleGlobalClick(e) {
      if (this.open && !this.$el.contains(e.target)) {
        this.closeAgentTaskBubble()
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleGlobalClick)
    // Auto-position below the trigger button if no x/y set
    if (this.agentTaskBubble.x == null) {
      const topbar = document.getElementById('mainTopbar')
      if (topbar) {
        const rect = topbar.getBoundingClientRect()
        this.$store.commit('SET_AGENT_TASK_BUBBLE', { x: rect.right - 360, y: rect.bottom + 8 })
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick)
  }
}
</script>
